import React, { useEffect, useState } from "react";
import banner from "../../src/images/banner.webp";
import bookIcon from "../images/bookIcon.svg";
import financeIcon from "../images/financeIcon.svg";
import ScientificIcon from "../images/ScientificIcon.svg";
import docx from "../images/docx.png";
import doc from "../images/doc.png";
import md from "../images/md.png";
import textIcon from "../images/text.png";
import pdfIcon from "../images/pdfIcon.png";

import legalIcon from "../images/legal.svg";
import productIcon from "../images/product.svg";
import employeeTrainginIcon from "../images/employeeTrainginIcon.svg";
import { getDataFromLocalStorage } from "../util/localStorage";

const HomeComponent = () => {
  const [userInfo, setuserIinfo] = useState();
  useEffect(() => {
    const userInfo = getDataFromLocalStorage("userInfo");
    setuserIinfo(userInfo);
    console.log("userInfo", userInfo);
  }, []);
  return (
    <>
      <div className=" bg-[#062427] flex-1 flex-col flex sm:mt[10px] mt-[50px]">
        <div className="bannerTitle  w-full block max-w-[1080px] mx-auto pt-[250px] p-[50px] text-white absolute z-[11]">
          <h1 className="text-[56px] pb-[15px] text-[#fff]">
            Your Intelligent Conversation Partner.
          </h1>
          <p className="max-w-[675px] text-[17px] mb-[15px]">
            Experience smarter conversations and instant solutions with
            DocLift.ai, your AI-powered chat partner.
          </p>
          <p className="max-w-[675px] text-[20px] mb-[15px]">
            We support a variety of file formats:
            <ul className="flex flex-row">
              <li className="mr-2">
                <span className="bg-[#000] p-[11px] inline-block rounded-[100%] mt-2">
                  <img src={docx} className="h-[38px]" alt="codx icon" />
                </span>
              </li>
              <li className="mr-2">
                <span className="bg-[#000] p-[11px] inline-block rounded-[100%] mt-2">
                  <img src={doc} className="h-[38px]" alt="codx icon" />
                </span>
              </li>
              <li className="mr-2">
                <span className="bg-[#000] p-[11px] inline-block rounded-[100%] mt-2">
                  <img src={pdfIcon} className="h-[38px]" alt="codx icon" />
                </span>
              </li>
              <li className="mr-2">
                <span className="bg-[#000] p-[11px] inline-block rounded-[100%] mt-2">
                  <img src={md} className="h-[38px]" alt="codx icon" />
                </span>
              </li>
              <li className="mr-2">
                <span className="bg-[#000] p-[11px] inline-block rounded-[100%] mt-2">
                  <img src={textIcon} className="h-[38px]" alt="codx icon" />
                </span>
              </li>
            </ul>
          </p>
          <div>
            <a
              className="bg-[#aa72ce] rounded-[4px] text-[#fff] sm:text-[16px] text-[14px] sm:px-[15px] px-[10px] py-[5px] sm:py-[15px] inline-block mt-[20px]"
              href={userInfo ? "/dashboard" : "/login"}
            >
              GET STARTED
            </a>
          </div>
        </div>

        <div className="w-full">
          <div className="banner">
            <img src={banner} className="w-full" />
          </div>
        </div>
      </div>
      <div className="w-full useCase">
        <div className="w-full mb-[60px]">
          <h2 className="text-center pt-[40px] text-[40px]">
            Chat with any PDF document
          </h2>
          <div className="homeBoxTitle text-center">
            <span className="text-[20px]">
              Explore a variety of use cases to chat with PDF documents using
              the best ChatPDF app
            </span>
          </div>
        </div>
        <div className="w-full">
          <div className="w-full useCaseRow max-w-[1080px] mx-auto bg-[#141A2A] flex flex-row flex-wrap">
            <div className="w-1/2 border border-[#343846] py-4 px-8 hover:bg-[#141A2A] bg-[#1b1d25]">
              <div className="w-full mt-8">
                <img src={bookIcon} alt="book" className="mb-4 h-[40px]" />
              </div>
              <div className="w-full text-white text-white text-[18px] mb-4 font-semibold">
                Books
              </div>
              <div className="w-full text-[#fff] mb-4">
                Step into a whole new reading experience! With DocLift.AI, chat
                with your favorite books and enjoy interactive conversations
                that make the pages come alive.
              </div>
            </div>
            <div className="w-1/2 border border-[#343846] py-4 px-8 hover:bg-[#141A2A] bg-[#1b1d25]">
              <div className="w-full mt-8">
                <img
                  src={ScientificIcon}
                  alt="book"
                  className="mb-4 h-[40px]"
                />
              </div>
              <div className="w-full text-white text-white text-[18px] mb-4 font-semibold">
                Scientific papers
              </div>
              <div className="w-full text-[#fff] mb-4">
                Elevate your research with DocLift.AI. Collaborate seamlessly
                and uncover insights effortlessly through a simple chat
                interface designed for scientific papers.
              </div>
            </div>
            <div className="w-1/2 border border-[#343846] py-4 px-8 hover:bg-[#141A2A] bg-[#1b1d25]">
              <div className="w-full mt-8">
                <img src={financeIcon} alt="book" className="mb-4 h-[40px]" />
              </div>
              <div className="w-full text-white text-white text-[18px] mb-4 font-semibold">
                Financial reports
              </div>
              <div className="w-full text-[#fff] mb-4">
                Forget boring number crunching! With DocLift.AI, you can chat
                with your financial reports and get quick, clear answers in no
                time.
              </div>
            </div>
            <div className="w-1/2 border border-[#343846] py-4 px-8 hover:bg-[#141A2A] bg-[#1b1d25]">
              <div className="w-full mt-8">
                <img src={productIcon} alt="book" className="mb-4 h-[40px]" />
              </div>
              <div className="w-full text-white text-white text-[18px] mb-4 font-semibold">
                Product user manuals
              </div>
              <div className="w-full text-[#fff] mb-4">
                Struggling to set up your gadget? Chat with your user manual
                using DocLift.AI for instant, easy-to-understand guidance that
                gets you up and running in no time.
              </div>
            </div>
            <div className="w-1/2 border border-[#343846] py-4 px-8 hover:bg-[#141A2A] bg-[#1b1d25]">
              <div className="w-full mt-8">
                <img src={legalIcon} alt="book" className="mb-4 h-[40px]" />
              </div>
              <div className="w-full text-white text-white text-[18px] mb-4 font-semibold">
                Legal documents
              </div>
              <div className="w-full text-[#fff] mb-4">
                Say goodbye to the hassle of deciphering legal jargon! With
                DocLift.AI, understanding and discussing legal documents has
                never been easier.
              </div>
            </div>
            <div className="w-1/2 border border-[#343846] py-4 px-8 hover:bg-[#141A2A] bg-[#1b1d25]">
              <div className="w-full mt-8">
                <img
                  src={employeeTrainginIcon}
                  alt="book"
                  className="mb-4 h-[40px]"
                />
              </div>
              <div className="w-full text-white text-white text-[18px] mb-4 font-semibold">
                Employee training documents
              </div>
              <div className="w-full text-[#fff] mb-4">
                Say hello to engaging training sessions! With DocLift.AI, your
                training documents come to life, making learning enjoyable,
                interactive, and as simple as having a conversation.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full bg-[#efefef] px-[10px] pt-[30px] mt-16 homeGetStarted">
        <div className="w-full mb-[60px]">
          {/* <h2 className="text-center pt-[40px] text-[40px]">Get started</h2> */}
          <div className="homeBoxTitle text-center">
            <span className="text-[30px]">
              Upload a document and start chatting with it today.
            </span>
          </div>
          <div className="flex justify-center pb-8">
            {!userInfo ? (
              <a
                className="bg-[#aa72ce] rounded-[4px] text-[#fff] sm:text-[16px] text-[14px] sm:px-[15px] px-[10px] py-[5px] sm:py-[15px] inline-block mt-[20px]"
                href="/login"
              >
                Sign up
              </a>
            ) : (
              <a
                className="bg-[#aa72ce] rounded-[4px] text-[#fff] sm:text-[16px] text-[14px] sm:px-[15px] px-[10px] py-[5px] sm:py-[15px] inline-block mt-[20px]"
                href={userInfo ? "/dashboard" : "/login"}
              >
                GET STARTED
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeComponent;
